module.exports = __webpack_public_path__ + "img/garantie-soins-courants.ac7204a6.svg";